<template>
    <footer class="footer">
        <div class="container">
            <div class="columns">
                <div class="column">
                    <h4>Our Policies</h4>
                    <ul>
                        <li><router-link :to="{name: 'privacy'}">Privacy Policy</router-link></li>
                        <li><router-link :to="{name: 'terms'}">Terms and Conditions</router-link></li>
                        <li><router-link :to="{name: 'reservations'}">Reservations Guanteed</router-link></li>
                    </ul>
                </div>
                <div class="column">
                    <h4>Personal Consierge</h4>
                    <div class="contacts">
                        <img src="@/assets/contacts.png" alt="" />
                        <div>
                            <p>Do you have travel questions?</p>
                            <p>Contact your Personal Concierge today!</p>
                            <p><b class="blue-color">Email:</b> Service@MyVacationBank.com</p>
                            <p><b class="blue-color">Phone:</b> +1 123 456 78 90</p>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <h4>Tryp360.club</h4>
                    <ul>
                        <li>
                            <a class="goto" href="#">
                                <svg width="22" height="24" viewBox="0 0 22 24">
                                    <path
                                        d="M10.6562 0C16.543 0 21.3125 5.20312 21.3125 11.625C21.3125 18.0469 16.543 23.25 10.6562 23.25C4.76953 23.25 0 18.0469 0 11.625C0 5.20312 4.76953 0 10.6562 0ZM5.67188 13.6875H10.6562V17.0109C10.6562 17.5125 11.2148 17.7656 11.5371 17.4094L16.4484 12.0234C16.6504 11.8031 16.6504 11.4516 16.4484 11.2313L11.5371 5.84063C11.2105 5.48438 10.6562 5.7375 10.6562 6.23906V9.5625H5.67188C5.38828 9.5625 5.15625 9.81563 5.15625 10.125V13.125C5.15625 13.4344 5.38828 13.6875 5.67188 13.6875Z"
                                        fill="#0D9FF2"
                                    />
                                </svg>
                                Enroll now to enter!</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer'
};
</script>

<style lang="scss" scoped>
.footer {
    display: block;
    background: $light;
    padding: $gap 0;
    font-size: 14px;

    h4 {
        font-size: 18px;
        font-weight: bold;
        margin: 0 0 $gap;
        color: $blue;
    }

    ul {
        list-style: none;
        margin: 0;
        padding: 0;

        li {
            margin: 0 0 4px;
        }
    }

    .contacts {
        img {
            float: left;
            margin-right: $gap;
        }

        div {
            overflow: hidden;
        }

        p {
            margin: 0 0 4px;
            color: #828282;
        }
    }

    .goto {
        svg {
            display: inline;
            vertical-align: middle;
        }
    }
}
</style>
